import { render, staticRenderFns } from "./BattleWaitingForFinish.vue?vue&type=template&id=6dec4e75&"
import script from "./BattleWaitingForFinish.vue?vue&type=script&lang=js&"
export * from "./BattleWaitingForFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports